import React, { FC, ReactElement, ReactNode, useMemo } from 'react'
import { RouterConfigEntry } from '../../../Types/Types'
import { useRouterConfig } from '../../../Hooks/useRouterConfig'
import { HeaderTop } from './Components/HeaderTop'
import { HeaderSidebar } from './Components/HeaderSidebar'
import { RouteID } from './Types/Types'

type Props = {
    routeID: Definable<RouteID>
    children: ReactNode
}

export const Header: FC<Props> = ({ routeID, children }: Props): ReactElement => {
    const routerConfig: Nullable<RouterConfigEntry> = useRouterConfig()

    const disableHeader: boolean = useMemo((): boolean => !!routerConfig?.disableHeader, [routerConfig, routeID])

    return disableHeader ? (
        <section className='router-main-content-section'>{children}</section>
    ) : (
        <div className='main-nav-container'>
            <header className='router-header'>
                <HeaderTop routeID={routeID} />
            </header>
            <section className='router-main-content-section'>
                <aside className='router-sidebar'>
                    <HeaderSidebar routeID={routeID} />
                </aside>
                {children}
            </section>
        </div>
    )
}
